import dayjs from "dayjs";
import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";
import { isPending } from "../../leaveStatus";

/**
 * Mirrors the payload views/leave/from builds. The table already seeds its edit
 * dialog straight from the row (`setById(row)`), so the row is a complete
 * source and no detail fetch is needed — which is required here anyway, since
 * the leave-user endpoint has no getById.
 *
 * `end_date`, `status_name`, `comments` and `approved_by_name` are backend-owned
 * and stay read-only, and the whole card locks once the request leaves pending —
 * the same rule the table's edit and cancel buttons follow.
 */
export default defineInlineEdit({
  api: "leaveUser",
  hydrate: false,
  canEdit: isPending,
  toPayload: (source) => ({
    start_date: dayjs(source.start_date).format("YYYY-MM-DD"),
    total_days: Number(source.total_days),
    reason: source.reason ?? "",
  }),
  fields: {
    start_date: {
      label: "تاريخ البداية",
      type: "date",
      required: true,
    },
    total_days: {
      label: "عدد الأيام",
      type: "number",
      required: true,
      toPatch: (value) => ({ total_days: Number(value) }),
    },
    reason: { label: "السبب", type: "multiline", required: true },
  },
});
